(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["tmg-cobrand-bar"] && !Shopify.designMode) return;
  try {
    (() => {
    const start = () => {
        const bar = document.querySelector('[data-tmg-cobrand-bar]');
        const anchor = bar?.parentElement;
        if (!bar || !anchor) return;
        const position = () => {
            if (bar.hidden) return;
            const header = ['#header', '#mobile-header']
                .map(selector => document.querySelector(selector))
                .find(element => element && element.getBoundingClientRect().height > 0);
            if (!header) return;
            const logo = header.querySelector('.header__brand, .mobile-logo');
            if (!logo) return;
            if (anchor.parentElement !== header) header.appendChild(anchor);
            const h = header.getBoundingClientRect();
            const l = logo.getBoundingClientRect();
            const a = anchor.getBoundingClientRect();
            const compact = l.left - h.left < 340;
            bar.toggleAttribute('data-compact', compact);
            bar.style.maxWidth = `${compact ? l.width : Math.min(420, l.left - h.left - 32)}px`;
            bar.style.width = compact ? `${l.width}px` : 'max-content';
            const height = bar.getBoundingClientRect().height;
            const top = compact
                ? Math.min(l.bottom + 3, h.bottom - height - 2)
                : h.top + (h.height - height) / 2;
            bar.style.top = `${top - a.top}px`;
            bar.style.insetInlineStart = `${(compact ? l.left : h.left + 16) - a.left}px`;
        };
        let frame;
        const schedule = () => {
            cancelAnimationFrame(frame);
            frame = requestAnimationFrame(position);
        };
        new MutationObserver(schedule).observe(bar, {
            attributes: true, attributeFilter: ['hidden'], childList: true, subtree: true,
        });
        const resize = new ResizeObserver(schedule);
        document.querySelectorAll('#header, #mobile-header, .header__brand, .mobile-logo')
            .forEach(element => resize.observe(element));
        window.addEventListener('resize', schedule, {passive: true});
        window.addEventListener('scroll', schedule, {passive: true});
        schedule();
    };
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start, {once: true});
    else start();
})();
  } catch(e) { console.error(e); }
})();

})();
